import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import App from './App'
import router from './router'
import store from './store'
import '@/vab'
// 导入水印组件
import Watermark from './components/watermark/index.js'
/**
 * @author chuzhixin 1204505056@qq.com
 * @description 正式环境默认使用mock，正式项目记得注释后再打包
 */
// if (process.env.NODE_REQUEST === 'mock') {
//   const { mockXHR } = require('@/utils/static')
//   mockXHR()
// }
export {router}

createApp(App).use(store).use(router).use(Antd).use(Watermark).mount('#app')
